import {es} from './utils/translations/es';
import {en} from './utils/translations/en';
import {fr} from './utils/translations/fr';
import {de} from './utils/translations/de';
import {it} from './utils/translations/it';
import {pt} from './utils/translations/pt';
import {tr} from './utils/translations/tr';
import {jp} from './utils/translations/jp';
import {cn} from './utils/translations/cn';
import {sa} from './utils/translations/sa';
import {nl} from './utils/translations/nl';
import {pl} from './utils/translations/pl';
import {sv} from './utils/translations/sv';
import {cs} from './utils/translations/cs';
import {ko} from './utils/translations/ko';
import { hu } from './utils/translations/hu';
import { ru } from './utils/translations/ru';

// Ready translated locale messages
export const messages = {
  en: en,
  es: es,
  fr: fr,
  de: de,
  it: it,
  pt: pt,
  tr: tr,
  jp: jp,
  cn: cn,
  sa: sa,
  nl: nl,
  pl: pl,
  sv: sv,
  cs: cs,
  ko: ko,
  ru: ru,
  hu: hu
};

export default messages;
